import { FunctionComponent } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Row, Space } from 'antd';
import { getProject } from '@hub/helpers/get-project';
import { cryptoCoins, CurrencyType } from '@monorepo/client-common';
import { IUnitTestProps, WithdrawPayload } from '@monorepo/client-types';
import {
  CurrencyAvatar,
  FormInput,
  FormSelect,
  TextComponent,
} from '@monorepo/react-components';
import { useResponsiveness } from '@monorepo/react-hooks';

const { project } = getProject();

interface Props extends IUnitTestProps {
  form: UseFormReturn<WithdrawPayload>;
}

const CryptoWithdraw: FunctionComponent<Props> = ({ form, testId }) => {
  const { t } = useTranslation(['withdrawFunds']);
  const { isMobile } = useResponsiveness();
  const colSpan = isMobile ? 24 : 12;

  return (
    <Row gutter={12} className="w-full" data-testid={testId}>
      <Col span={colSpan}>
        <FormInput
          text={t('withdrawFunds:wallet_address')}
          form={form}
          controllerProps={{
            name: 'metadata.walletAddress',
            rules: { required: true },
          }}
        />
      </Col>
      <Col span={colSpan}>
        <FormSelect
          form={form}
          controllerProps={{
            name: 'metadata.cryptoCurrency',
            rules: { required: true },
          }}
          text={t('withdrawFunds:crypto_currency')}
          options={cryptoCoins.map((curr) => ({
            label: (
              <Space>
                <CurrencyAvatar
                  size={'small'}
                  name={curr.value}
                  type={CurrencyType.Crypto}
                  project={project}
                />
                <TextComponent level={7}>{curr.text}</TextComponent>
              </Space>
            ),
            value: curr.value,
          }))}
        />
      </Col>
    </Row>
  );
};

export default CryptoWithdraw;
